import { SHOW, HIDE, PENDING, DONE } from "./actions"

export default {
    state: {
        loading: false,
        requestsPending: 0,
    },
    actions: {
        [SHOW]: ({ commit }) => {
            commit(SHOW);
        },
        [HIDE]: ({ commit }) => {
            commit(HIDE);
        },
        [PENDING]: ({ commit }) => {
            commit(PENDING);
        },
        [DONE]: ({ commit }) => {
            commit(DONE);
        }
    },
    mutations: {
        [SHOW]: (state) => {
            state.loading = true;
        },
        [HIDE]: (state) => {
            state.loading = false;
        },
        [PENDING]: (state) => {
            if (state.requestsPending === 0) {
                state.loading = true;
            }

            state.requestsPending++;
        },
        [DONE]: (state) => {
            if (state.requestsPending >= 1) {
                state.requestsPending--;
            }

            if (state.requestsPending <= 0) {
                state.loading = false;
            }
        }
    }
};